<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg"
  >
    <div class="flex-auto p-4">
      <div class="flex flex-wrap">
        <div class="relative w-auto flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full"
            :class="[statIconColor]"
          >
            <i :class="[statIconName]"></i>
          </div>
        </div>
        <div class="flex flex-col w-full pr-4 max-w-full flex-grow flex-1 ml-3">
          <span class="text-blueGray-700 uppercase font-bold text-xl">
            {{ pCnt }}<template v-if="pTotal">/{{ pTotal }}</template>
          </span>
          <span class="text-blueGray-700 uppercase font-bold text-xs">
            {{ statSubtitle }}
          </span>
        </div>
        <!-- <div class="relative w-full pr-4 max-w-full flex-grow flex-1 ml-3 mt-5">
          <span class="text-blueGray-700 uppercase font-bold text-xl">
            {{ statSubtitle }}
          </span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from "vue";

const props = defineProps({
  statSubtitle: {
    type: String,
    default: "Traffic",
  },
  statIconName: {
    type: String,
    default: "far fa-chart-bar",
  },
  statIconColor: {
    type: String,
    default: "bg-red-500",
  },
  pCnt: [String, Number],
  pTotal: [String, Number],
});
</script>
